"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _ExamTemplate = _interopRequireDefault(require("../factories/ExamTemplate.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_ExamTemplate.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.EXAM_TEMPLATES_LIST_FETCHED] = function examTemplatesListFetch(state, payload) {
  return state.withMutations(function (newState) {
    payload.list.forEach(function (examTemplate) {
      newState.set(examTemplate.id, new _ExamTemplate.default({
        id: examTemplate.id,
        attributes: {
          name: examTemplate.name,
          deleted: examTemplate.deleted,
          created_at: examTemplate.created_at,
          question_limit: examTemplate.question_limit,
          // represents the number of original questions on template
          question_ids: JSON.parse("[" + examTemplate.question_ids.slice(1, examTemplate.question_ids.length - 1) + "]") // represents actual questions on template
        },

        relationships: {
          creator: {
            data: {
              id: examTemplate.user_id
            }
          },
          question_bank: {
            data: {
              id: examTemplate.question_bank_id
            }
          }
        }
      }));
    });
  });
};
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.EXAM_TEMPLATES_FETCHED] = stateHelper.set;
reducers[_constants.EXAM_TEMPLATE_FETCHED] = stateHelper.set;
reducers[_constants.EXAM_TEMPLATE_CREATED] = stateHelper.set;
reducers[_constants.EXAM_TEMPLATE_UPDATED] = stateHelper.set;
reducers[_constants.ORGANIZATION_SELECTED] = stateHelper.reset;
var _default = exports.default = stateHelper.createReducer(reducers);